import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "./WebsiteDevelopment.css";

function WebsiteDevelopment() {
  const navigate = useNavigate();

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you provide website development services in USA, Dubai and Saudi Arabia?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. SamSoftix provides remote website development services for clients in the USA, UAE (Dubai), and Saudi Arabia with global standards and flexible communication."
        }
      },
      {
        "@type": "Question",
        "name": "How much does a professional website cost?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The cost depends on project complexity, features, and integrations. Contact us for a custom international quote."
        }
      },
      {
        "@type": "Question",
        "name": "Will my website follow international SEO standards?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. We build websites optimized for global search engines including Google USA, UAE and Saudi Arabia."
        }
      }
    ]
  };

  return (
    <main className="webdev-page">
      <Helmet>
        <title>International Website Development Company | USA, Dubai & Saudi Arabia | SamSoftix</title>
        <meta
          name="description"
          content="Professional website development company serving USA, Dubai (UAE) and Saudi Arabia. We build high-performance, SEO-optimized business websites for global growth."
        />
        <meta
          name="keywords"
          content="Website development USA, Web development Dubai, Website development Saudi Arabia, International web development company, SEO website design"
        />
        <link rel="canonical" href="https://www.samsoftix.com/website_Service_Samsoftix" />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      {/* Hero Section */}
      <section className="webdev-hero">
        <h1>International Website Development Company</h1>
        <p>
          Serving businesses in <strong>USA</strong>, <strong>Dubai (UAE)</strong>, 
          and <strong>Saudi Arabia</strong> with high-performance, secure, 
          and SEO-optimized websites designed to generate leads and sales.
        </p>
        <button onClick={() => navigate("/serviceBooking")} className="webdev-btn">
          Book Free Strategy Call
        </button>
      </section>

      {/* Why Choose Us */}
      <section className="webdev-section">
        <h2>Why Businesses in USA, UAE & KSA Choose Us</h2>
        <ul>
          <li>✔ Modern, conversion-focused design</li>
          <li>✔ Google SEO optimization (International targeting)</li>
          <li>✔ Fast-loading & secure architecture</li>
          <li>✔ Mobile-first responsive development</li>
          <li>✔ Scalable cloud hosting solutions</li>
          <li>✔ Remote collaboration & timezone flexibility</li>
        </ul>
      </section>

      {/* Business Impact */}
      <section className="webdev-section">
        <h2>How Our Websites Improve Your Business</h2>
        <p>
          A professionally developed website increases credibility, improves 
          online visibility, and converts visitors into customers. 
          We help businesses expand globally with SEO-optimized architecture 
          tailored for competitive markets like USA, Dubai and Saudi Arabia.
        </p>
      </section>

      {/* Technologies */}
      <section className="webdev-section">
        <h2>Technologies We Use</h2>
        <p>
          React.js, Next.js, Node.js, WordPress, Shopify, AWS, Firebase, 
          and secure cloud infrastructure for scalable global performance.
        </p>
      </section>

      {/* Process */}
      <section className="webdev-section">
        <h2>Our International Development Process</h2>
        <ol>
          <li>Market Research & Competitor Analysis</li>
          <li>UX Strategy for Target Country</li>
          <li>Development with SEO Structure</li>
          <li>Speed & Performance Optimization</li>
          <li>Launch, Monitoring & Ongoing Support</li>
        </ol>
      </section>

      {/* FAQ */}
      <section className="webdev-section">
        <h2>Frequently Asked Questions</h2>

        <h3>Do you work with US and Middle East clients?</h3>
        <p>Yes. We provide 100% remote services with global communication standards.</p>

        <h3>Will my website rank in USA or Dubai Google search?</h3>
        <p>Yes. We structure websites for international SEO targeting specific countries.</p>

        <h3>Do you offer ongoing maintenance?</h3>
        <p>Yes. We provide maintenance, updates and security monitoring plans.</p>
      </section>

      {/* CTA */}
      <section className="webdev-cta">
        <h2>Ready to Grow Internationally?</h2>
        <p>
          Partner with SamSoftix to build a powerful website that competes in 
          USA, UAE and Saudi markets.
        </p>
        <button onClick={() => navigate("/serviceBooking")} className="webdev-btn">
          Start Your Global Project
        </button>
      </section>
    </main>
  );
}

export default WebsiteDevelopment;